import { createFileRoute } from '@tanstack/react-router';

import { getSystemUserQueryOptions } from '@/_pages/system-users/api-service';
import Loading from '@/_pages/system-users/profile/loading';

export const Route = createFileRoute('/_private/system-users/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getSystemUserQueryOptions(opts.params.id)),
  // params: {
  //   parse: (params) => ({
  //     id: z.number().int().parse(Number(params.id)),
  //   }),
  //   stringify: ({ id }) => ({ id: `${id}` }),
  // },
  pendingComponent: Loading,
});
